import { Directive, ElementRef, HostBinding, HostListener } from '@angular/core';

@Directive({
  selector: '[appKeyboardScrollable]',
  standalone: true
})
export class KeyboardScrollableDirective {
  private static readonly label = 'Table Scrollbar - use left/right arrow keys to scroll table';
  private static readonly minScrollStep = 48;

  constructor(private readonly elementRef: ElementRef<HTMLElement>) {}

  @HostBinding('attr.tabindex') readonly tabIndex = '0';
  @HostBinding('attr.role') readonly role = 'region';
  @HostBinding('attr.aria-label') readonly ariaLabel = KeyboardScrollableDirective.label;
  @HostBinding('class.keyboard-scrollable') readonly keyboardScrollableClass = true;

  @HostListener('keydown', ['$event'])
  onKeydown(event: KeyboardEvent): void {
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') {
      return;
    }

    event.preventDefault();
    const host = this.elementRef.nativeElement;
    const direction = event.key === 'ArrowRight' ? 1 : -1;
    const scrollStep = Math.max(Math.round(host.clientWidth * 0.75), KeyboardScrollableDirective.minScrollStep);
    host.scrollLeft += direction * scrollStep;
  }
}
